/**
 * usePresence — atualiza `profiles.last_seen_at` periodicamente enquanto
 * o app esta ativo. Usado pra mostrar bolinha verde "online agora" pro PT
 * ver quais alunos estao com o app aberto recentemente.
 *
 * Comportamento:
 *   - Chama UPDATE imediato ao montar (quando user logado)
 *   - Repete UPDATE a cada 1min via setInterval
 *   - Cleanup do interval no unmount
 *   - Falha silenciosa: se UPDATE der erro (rede, RLS), nao quebra o app
 *
 * Definicao de "online" pelo lado do PT:
 *   - last_seen_at <= 5min atras = online (bolinha verde)
 *   - last_seen_at > 5min OU NULL = offline (texto "Ultimo login: ha X")
 *
 * Custo: ~1 UPDATE por minuto por usuario ativo. Pra 100 users = 100 reqs/min.
 *
 * Chamado uma vez no topo do RootLayoutNav em `app/_layout.tsx`.
 */
import { useEffect } from 'react';
import { supabase } from '@/lib/supabase';

const PING_INTERVAL_MS = 60_000; // 1min

export function usePresence(userId: string | null | undefined) {
  useEffect(() => {
    if (!userId) return;

    async function ping() {
      try {
        await supabase
          .from('profiles')
          .update({ last_seen_at: new Date().toISOString() })
          .eq('id', userId);
      } catch {
        // Falha silenciosa - presence nao quebra o app
      }
    }

    // Ping imediato + a cada PING_INTERVAL_MS enquanto montado
    ping();
    const interval = setInterval(ping, PING_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [userId]);
}
